import { Intent } from "@blueprintjs/core";
import { Button } from "components/buttons";
import { ShowHide } from "components/layout";
import { Modal, ModalSize, NotificationToaster } from "components/notifications";
import PropTypes from "prop-types";
import React from "react";
import { GreyFleetService } from 'services';

const badRequestCode = 400;

export function GreyFleetInsuranceValidationModal({
    isOpen,
    onClose,
    onSuccess,
    onNext,
    insuranceDetails,
    actionInProgress,
    setActionInProgress,
    nextInsuranceId = null
}) {

    function validateInsurance(withNext = false) {
        if (actionInProgress || !insuranceDetails) {
            return;
        }
        
        setActionInProgress(true);

        GreyFleetService.validateInsurance(insuranceDetails.insuranceDocumentId)
            .then(
                () => {
                    NotificationToaster.show(Intent.SUCCESS, "Insurance validated successfully.");
                    if (withNext) {
                        if (onNext) {
                            onNext();
                        } else {
                            onSuccess();
                        }
                    } else {
                        onSuccess();
                    }
                },
                (error) => {
                    if (error?.response?.status === badRequestCode) {
                        NotificationToaster.show(Intent.WARNING, error.response.data);
                    } else {
                        NotificationToaster.show(Intent.DANGER, "Insurance cannot be validated. Please try again.");
                    }
                }
            )
            .catch(() => {
                NotificationToaster.show(Intent.DANGER, "Failed validating insurance.");
            })
            .finally(() => {
                setActionInProgress(false);
            });
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={"Validate Insurance"}
            size={ModalSize.SMALL}
            clickOutsideClose={!actionInProgress}
            showCloseButton={false}
            footer={
                <div className="inline-items push-right">
                    <Button text="Cancel" intent={Intent.NONE} onClick={onClose} disabled={actionInProgress}></Button>
                    <Button text="Validate" intent={Intent.PRIMARY} onClick={() => validateInsurance(false)} disabled={actionInProgress}></Button>
                    <ShowHide
                        evaluator={!!nextInsuranceId}
                        show={<Button text="Validate And Next" intent={Intent.PRIMARY} onClick={() => validateInsurance(true)} disabled={actionInProgress}></Button>}
                    />
                </div>
            }
        >
            <span className="text-intent-info">Are you sure you want to validate the insurance for this Grey Fleet Check?</span>
            <ShowHide
                evaluator={!!nextInsuranceId}
                show={
                    <div className="spacer-top">
                        <h3>Next Insurance Check ID</h3>
                        <span className="text-intent-info">{nextInsuranceId ?? 0}</span>
                    </div>
                }
            />
        </Modal>
    );
}

GreyFleetInsuranceValidationModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onNext: PropTypes.func,
    insuranceDetails: PropTypes.object,
    actionInProgress: PropTypes.bool.isRequired,
    setActionInProgress: PropTypes.func.isRequired,
    nextInsuranceId: PropTypes.number
};
